import { render, staticRenderFns } from "./MailgunMailDriver.vue?vue&type=template&id=71ebdbde&"
import script from "./MailgunMailDriver.vue?vue&type=script&lang=js&"
export * from "./MailgunMailDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/xbill/public_html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71ebdbde')) {
      api.createRecord('71ebdbde', component.options)
    } else {
      api.reload('71ebdbde', component.options)
    }
    module.hot.accept("./MailgunMailDriver.vue?vue&type=template&id=71ebdbde&", function () {
      api.rerender('71ebdbde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/settings/mail-driver/MailgunMailDriver.vue"
export default component.exports